import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ContentPropertyType, IntegerPropertyType, StringPropertyType, VmFunctionPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { ButtonView } from "./button-view"


export class ButtonComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Button';
        this.canAcceptContent = true;
        this.canAcceptMultipleContent = false;

        this.addProperty("Content","",new ContentPropertyType(this),null,true);
        this.addProperty("OnClick","data-b-event-click",new VmFunctionPropertyType(this),null,false);
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    protected getClassDefaultValue(){
        return "primary button";
    }

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ButtonElement(parent);
        return result;
    }
        
}

export class ButtonElement extends ChildAcceptableFormBuilderElement{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ButtonView();
    }
    public getTypeId(): string {
        return "VM-F6554E40-7D78-4E39-AF3F-D1BA9CD9D47C"
    }
    
    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
    public set OnClick(v: any) { this._OnClick = v; } public get OnClick(): any { return this._OnClick;} private _OnClick: any;
        
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitButton(this,parameter);
    }
    addChildInternal(element: FormBuilderElement): void {
        this.children.update(...[element]);
        this.Content = element;
    }
    removeChild(element: FormBuilderElement): void {
        if(element && this.Content && this.Content.self == element.self){
            this.children.clear();
            this.Content = null;
        }
    }
}
